import { Store } from '@ngrx/store';
import { ICustomerGroupsFeature } from './customer-groups.feature.state';
import { getFailures, getIsLoading, getCustomerGroups, getSelectedCustomerGroup } from './customer-groups.selectors';
import { Injectable } from '@angular/core';
import { selectCustomerGroupAction } from './customer-groups.actions';

@Injectable()
export class CustomerGroupsFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);
  public customerGroups$ = this.store.select(getCustomerGroups);
  public selectedCustomerGroup$ = this.store.select(getSelectedCustomerGroup);

  constructor(private store: Store<ICustomerGroupsFeature>) {}

  public selectCustomerGroup(customerGroupId: number): void {
    this.store.dispatch(selectCustomerGroupAction({ customerGroupId }));
  }
}
